module.exports = {

    doublegame: {
        background: {
            image: "res/doublegame_background.jpg"
        },

        currentWinLabel: {
            position: {x: 250, y: 187},
            font: "arial_bold_24",
            align: "center"
        },

        nextWinLabel: {
            position: {x: 758, y: 187},
            font: "arial_bold_24",
            align: "center"
        },

        centralCard: {
            position: {x: 512.5, y: 325.3},
            redShirt: "shirt0.png",
            blueShirt: "shirt1.png",
            suitOffset: {x: 0, y: -1.5}
        },


        prefix: {
            suits: "",
            mini_suits: "mini_"
        },

        history: {
            length: 5,
            position: {x: 482.5, y: 242},
            cardOffset: 85
        },

        redButton: {
            position: {x: 220, y: 366},
            hitArea:'ellipse',
            state: {
                normal: "red.png",
                over: "red.png",
                pressed: "red_select.png",
                disabled: "red.png"
            }
        },

        blackButton: {
            position: {x: 815, y: 366},
            hitArea:'ellipse',
            state: {
                normal: "black.png",
                over: "black.png",
                pressed: "black_select.png",
                disabled: "black.png"
            }
        },

        sounds: {
            // win: "res/sounds/doublegame/win",
            lose: "res/sounds/doublegame/lose",
            rotate: "res/sounds/doublegame/rotate",
            blink: "res/sounds/doublegame/blink"
            // choice: "res/sounds/doublegame/select"
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./cfg/doublegame-config.js
// module id = 18
// module chunks = 0